import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { PageUrl } from '../../../../pages/utils/page-url';
import { useUrl } from '../../../../utils/api';
import { BrandLogo } from '../../../icons';
import type { HeaderLogoLinkProps } from './HeaderLogoLink.types';

export const HeaderLogoLink: FC<HeaderLogoLinkProps> = ({ className }) => {
    const homeUrl = useUrl(PageUrl.HOME_SHOW);

    return (
        <Link
            to={homeUrl}
            data-testid="header.logo.link"
            aria-label="Brand Logo Link"
            className={className}
        >
            <BrandLogo
                data-testid="header.logo.image"
                aria-label="Brand Logo"
                width={{ base: '108px', md: '180px' }}
                height={{ base: '24px', md: '40px' }}
            />
        </Link>
    );
};
